
    import Component from "vue-class-component";
    import Vue from "vue";
    import {Prop} from "vue-property-decorator";

    @Component
    export default class ApplicationHeader extends Vue {
        @Prop({required: true})
        applicationNumber!: string;

        @Prop({required: true})
        applicationName!: string;

        @Prop({required: true})
        certificateTypeLegalName!: string;

        @Prop({default: false})
        isDeleted!: boolean;
    }
